// extracted by mini-css-extract-plugin
export default {"header":"GradientHeader_header__hCW8Z","editButton":"GradientHeader_editButton__m0SZB"};